import { SELECTED_MFC } from '../constants';

const initialState = {
  id: 0,
  className: '',
  metroStation: null,
  name: '',
  address: {
    latitude: 0,
    longitude: 0,
    value: '',
    buses: '',
    shuttles: '',
    trams: '',
    trolleys: '',
    metroLocations: [{ distance: 0, metroStationId: 0 }],
  },
  officeStatus: 'ACTIVE',
};

const mfcReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECTED_MFC:
      return {
        ...initialState,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default mfcReducer;
